import { configureIguazuREST } from 'iguazu-rest';
import memberProducts from '@americanexpress/iguazu-resources/memberProducts';

const configureIguazuResources = () => {
  configureIguazuREST({
    getToState: (state) => state.getIn(['modules', 'axp-card-member-apply-root', 'resources']),
    // Add any other configuration values you already have (see https://github.com/americanexpress/iguazu-rest)
    resources: {
      memberProducts,
    },
    defaultOpts: {
      credentials: 'include',
    },
  });
};

configureIguazuResources();

export default configureIguazuResources;
